import React, { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import StepperNavigationButtons from "../StepperNavigationButtons";
import { IconPlus, IconRefresh } from '@tabler/icons-react';
import { _get } from "../../../../../apiClient";
import { useDispatch, useSelector } from 'react-redux';
import { profilesList } from "../../../../Redux/Actions/ProfileListAction";
import { useAuth } from "../../../../Context/store/context";
import { _showToast } from "../../../../../toastHelper";

const Studios = forwardRef(
  function Studios(props, ref) {
    const dispatch = useDispatch();
    const { showLoader, hideLoader } = useAuth();
    const myStudios = useSelector((state) => state.ProfilesList.profilesList);
    const [isInitialLoading, setInitialLoading] = useState(true);
    const [studios, setStudios] = useState([]);
    const [studio, setStudio] = useState({});

    const isEmptyObject = (obj) => {
      if (obj == undefined || obj == null) {
        return true;
      }
      return Object.keys(obj).length === 0 && obj.constructor === Object;
    };

    useEffect(() => {
      if (!isInitialLoading && myStudios) {
        let studiosArray = [getNoStudioProfile(), ...myStudios];
        setStudios(studiosArray);
        if (isEmptyObject(studio)) {
          let profile = null;
          if (props.data !=undefined && props.data >=0) {
            profile = studiosArray.find(x => x.id == props.data);
          }
          else {
            profile = studiosArray.find(x => x.isPrimary == true);
          }
          setStudio(profile ?? studiosArray[0]);
        }
      }
      else if (isInitialLoading) {
        fetchStudioProfiles();
      }

    }, [myStudios])

    const fetchStudioProfiles = async () => {
      showLoader();
      setInitialLoading(false);
      await _get('/studio-profiles')
        .then((response) => {
          dispatch(profilesList(response));
          hideLoader();
        })
        .catch((error) => {
          hideLoader();
          _showToast(error, "error");
        });
    }

    const handleStudioChange = (e) => {
      const selectedStudio = studios.find(x => x.id == e.target.value);
      setStudio(selectedStudio);
    };

    const validate = () => {
      if (studio?.id >= 0)
        return true;
      else
        return false;
    }

    const getData = () => {
      return studio.id;
    }

    useImperativeHandle(ref, () => ({
      getData: getData,
      validate: validate
    }));

    const getNoStudioProfile = () => {
      return {
        addressLine1: "",
        addressLine2: "",
        city: "",
        contactNo: "",
        country: "",
        email: "",
        facebook: "",
        id: 0,
        instagram: "",
        isPrimary: false,
        locationUrl: "",
        logo: "",
        pinCode: "",
        state: "",
        studioName: "No Studio Or No Footer",
        twitter: "",
        website: "",
        youtube: ""
      }
    }

    return (
      <div className="content d-block visible">
        <div className="content-header mb-3 d-flex justify-content-between flex-column flex-md-row">
          <div className="sec-titler">
            <h2 className="text-primary">My Studios</h2>
            <div className="title-shape"></div>
            <small className="fs-11 mb-0"></small>
          </div>
          <div className="mb-0 text-right d-flex d-md-block flex-row justify-content-end">
            <button className="btn btn-primary align-middle me-3" onClick={fetchStudioProfiles}>
              <IconRefresh className="me-sm-1 me-0" size={20} />
              Refresh Studios
            </button>

            <a className="btn btn-primary align-middle" href="/mystudios/add" target="_blank">
              <IconPlus className="me-sm-1 me-0" size={20} />
              Add Studio
            </a>
          </div>
        </div>
        <div className="row g-3">
          <div className="accordion mt-3">
            {
              (!studios || (studios && studios.length == 0)) && (
                <div className="row justify-content-center">
                  <div className="col-md-5 col-lg-4 col-11">
                    <div className="d-flex flex-column align-items-center">
                      <img src="/images/upload-images.svg" />
                      <div className="helper-message">
                        No studio profiles information available
                      </div>
                      <a type="button" className="mt-2 btn btn-primary" href="/mystudios/add" target="_blank">
                        <IconPlus className="me-sm-1 me-0" size={20} />
                        Add Studio
                      </a>
                    </div>
                  </div>
                </div>
              )
            }

            {studios && studios.length > 0 &&
              (
                <>
                  <div className="col-sm-12">
                    <label className="form-label" htmlFor="studios">
                      Studio Profiles<span style={{ color: "red", marginLeft: "4px" }}>*</span>
                    </label>
                    <select
                      id="studios"
                      name="studios"
                      className="form-select"
                      value={studio.id}
                      onChange={handleStudioChange}
                    >
                      {studios.map((studio, index) => (
                        <option key={studio.id} value={studio.id}>
                          {studio.studioName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="row g-3 mt-3">
                    <div className="col-sm-6">
                      <label className="form-label">
                        Studio Name
                      </label>
                      <input
                        type="text"
                        disabled
                        className="form-control"
                        placeholder="Studio Name"
                        value={studio?.studioName ?? ""}
                      />
                    </div>
                    <div className="col-sm-6">
                      <label className="form-label">
                        Email Address
                      </label>
                      <input
                        type="text"
                        disabled
                        className="form-control"
                        placeholder="Email Address"
                        value={studio?.email ?? ""}
                      />
                    </div>
                    <div className="col-sm-6">
                      <label className="form-label">
                        Contact Numner
                      </label>
                      <input
                        type="text"
                        disabled
                        className="form-control"
                        placeholder="Website"
                        value={studio?.contactNo ?? ""}
                      />
                    </div>
                    <div className="col-sm-6">
                      <label className="form-label">
                        Website
                      </label>
                      <input
                        type="text"
                        disabled
                        className="form-control"
                        placeholder="Website"
                        value={studio?.website ?? ""}
                      />
                    </div>
                  </div>
                </>
              )
            }
          </div>

          <StepperNavigationButtons index={props.index} steps={props.steps} navigate={props.navigate} />
        </div>
      </div>
    )
  });

export default Studios;
